import { constants } from "../constants";

export const createSession = (resp) => {
    const url = `${constants.ENDPOINTS.createAdyenSession}?entity_id=${resp.entity_id}&phone=${resp.phoneNumber}&email=${resp.emailAddress}`;
    return fetch(url).then(res => res.json());
};